import Link from "next/link"
import { ProductsSlider } from "@/components/shared/products-slider"
import type { FeaturedProductsGroup } from "@/services/triibo-service"
import {
  getProducts,
  type WooCommerceProduct,
} from "@/services/woo-commerce-service"
import { filterOutOfStockProducts } from "@/utilities"

interface FeaturedProductsSectionProps {
  data: {
    acf_fc_layout?: string
    featuredProductsGroup?: FeaturedProductsGroup[]
  }
}

interface ProductCategoryData {
  title: string
  slug: string
  products: WooCommerceProduct[]
}

const mountCategories = async (
  productGroups: FeaturedProductsGroup[]
): Promise<ProductCategoryData[]> => {
  const categories = await Promise.all(
    productGroups.map(async (group) => {
      const rootCategory =
        group.productCategory.find((category) => category.parent === 0) ||
        group.productCategory[0] ||
        []

      const categoryIds = group.productCategory.map(
        (category) => category.term_id
      )

      const products = await getProducts({
        per_page: 12,
        category: categoryIds.join(","),
        orderby: "date",
        order: "desc",
      })

      const availableProducts = filterOutOfStockProducts(products)

      return {
        title: group.mainTitleMainProducts,
        slug: rootCategory.slug,
        products: availableProducts,
      }
    })
  )

  return categories
}

export const FeaturedProductsSection = async ({
  data,
}: FeaturedProductsSectionProps) => {
  const productGroups = data?.featuredProductsGroup || []

  const categories = await mountCategories(productGroups)

  return (
    <>
      {categories.map(({ title, slug, products }) => {
        return (
          <section
            aria-label={title}
            className='w-full py-8'
            key={`${slug}-${title}`}
          >
            <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>
              <div className='flex items-center justify-between'>
                <h2 className='font-semibold text-2xl'>{title}</h2>
                <ul>
                  <li>
                    <Link
                      className='text-primary hover:underline'
                      href={`/categorias/${slug}`}
                      prefetch
                    >
                      Ver Todos
                    </Link>
                  </li>
                </ul>
              </div>
              <ProductsSlider products={products} title={title} />
            </div>
          </section>
        )
      })}
    </>
  )
}
